import React, { useState } from 'react';
import ShapeDrawer from '../ShapeDrawer';
import Canvas from '../Canvas';
import './spaces.css';

const Spaces = ({ contentLoading, setContentLoading }) => {
  const [formValues, setFormValues] = useState({
    name: '',
    description: '',
    length: '',
    height: '',
    birth: '',
  });
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleCloseDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <div className="spaces-container">
      <Canvas
        setFormValues={setFormValues}
        setDrawerVisible={setDrawerVisible}
        contentLoading={contentLoading} 
        setContentLoading={setContentLoading}
      />
      <ShapeDrawer
        formValues={formValues}
        setFormValues={setFormValues}
        visible={drawerVisible}
        onClose={handleCloseDrawer}
        onCancel={handleCloseDrawer}
      />

    </div>
  );
};

export default Spaces;
